import { render, staticRenderFns } from "./bankDc.vue?vue&type=template&id=91cedde6&scoped=true"
import script from "./bankDc.vue?vue&type=script&lang=js"
export * from "./bankDc.vue?vue&type=script&lang=js"
import style0 from "./bankDc.vue?vue&type=style&index=0&id=91cedde6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cedde6",
  null
  
)

export default component.exports